<template>
<div>
    <v-content class="grey lighten-5">
        <div :class="($vuetify.breakpoint.smAndDown) ? 'py-3' : 'py-4'">
            <v-card flat max-width="950px" class="mx-auto accent px-6 py-5" style="border-bottom-left-radius:0; border-bottom-right-radius:0;">
                <div class="d-flex justify-center align-center">
                    <div style="cursor:pointer" @click="open">
                        <v-img :src="require('@/assets/new-logo.png')" width="140px"></v-img>
                    </div>
                    <!-- <div class="white--text pr-2">
                        Online Shop
                    </div> -->
                </div>
            </v-card>

		    <router-view></router-view>

            <div class="caption text-center mt-10">
                Copyright © 2020 Young Potential Development LLC. All rights reserved.
            </div>
        </div>
    </v-content>
</div>
</template>

<script>
export default {
    mounted() {
        
    },
    methods: {
        open() {
            window.open('http://3stepstocollege.com', '_self')
        }
    }
}
</script>


